import type { FC } from "react";
import styled from "@emotion/styled";
import { useCallback } from "react";
import { renderSmartCard, type RenderSmartCardOptions } from "@/components/heads-up/cards";
import type { SmartCardRow } from "@/domains/tanstack-db";
import { useHeadsUpAnalytics } from "@/components/heads-up/analytics";

interface Props {
  cards: SmartCardRow[];
  cardRenderOptions: RenderSmartCardOptions;
}

export const HeadsUpContentView: FC<Props> = ({ cards, cardRenderOptions }) => {
  const analytics = useHeadsUpAnalytics();

  const buildSectionAnalyticsHandlers = useCallback(
    (sectionPositionIndex: number) => ({
      sectionPositionIndex,
      onItemPreviewOpen: analytics.trackHover,
      onItemClick: analytics.trackClick,
    }),
    [analytics]
  );

  return (
    <CardList>
      {cards.map((card, index) => {
        const content = renderSmartCard(card, {
          ...cardRenderOptions,
          analytics: buildSectionAnalyticsHandlers(index),
        });

        if (!content) return null;

        return (
          <CardItem key={card.id}>
            <CardContent>{content}</CardContent>
          </CardItem>
        );
      })}
    </CardList>
  );
};

const CardList = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["1"]};
`;
